<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="130px"
      class="form"
      size="small"
      :disabled="true"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group v-model="ruleForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label=" WEB是否展示："
            required
          >
            <el-radio-group v-model="ruleForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label=" 小程序是否展示："
            required
          >
            <el-radio-group v-model="ruleForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="PC端是否展示："
            required
          >
            <el-radio-group v-model="ruleForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="直播名称：" prop="name">
            <el-input
              placeholder="请输入直播名称"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col >
          <el-form-item label="直播时间：" prop="liveTime">
            <el-date-picker
              v-model="ruleForm.liveTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>


      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="直播封面："
            prop="coverUrl"
            :rules="{
              required: true,
              message: '请上传图片',
            }"
            :show-message="showError"
          >
          <!-- v-if="ruleForm.coverUrl" -->
            <div
              
              class="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showAppViewer = true"
                ></i>
   
              </div>
            </div>

          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="讲师：" prop="lecturerNameDesc" required>
            <el-input
              placeholder="请选择讲师"
              v-model="ruleForm.lecturerNameDesc"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="直播简介：" prop="introduction">
            <el-input
              type="textarea"
              :rows="10"
              placeholder="请输入直播简介"
              v-model="ruleForm.introduction"
              maxlength="1000"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-form-item label="直播学分要求：" prop="requireTime" required>
            <div>
              观看直播时长达到
              <el-input-number
                v-model="ruleForm.requireTime"
                :min="0"
                :step="5"
              ></el-input-number>
              分钟及以上，可获得直播学分
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="直播学分：" prop="credit" required>
            <el-input-number
                v-model="ruleForm.credit"
                :min="0"
                :precision="2" 
                :step="0.1"
              ></el-input-number>
              直播结束后第二天结算学分
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="直播转码：" prop="isTransform" required>
            <el-radio-group v-model="ruleForm.isTransform">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
            <div>直播转码开启时，会使用咪咕转码服务</div>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <el-row>
        <el-col>
          <div style="text-align: center">
            <el-button @click="goBack">返回</el-button>
          </div>
        </el-col>
      </el-row>

    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showAppViewer"
      :on-close="closeAppViewer"
      :url-list="[ruleForm.coverUrl]"
    />

  </div>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

import { liveRoomInfo } from "@/api/liveRoom";

export default {
  components: { ElImageViewer },
  data() {
    return {
      page: 1,
      more: true,
      data: [],
      addTitle: "直播间详情",
      ruleForm: {
        name: "",
        liveTime: [],
        coverUrl: "",
        isApplet: "",
        isApp: "",
        isWeb: "",
        isPc: "",
        credit: "",
        requireTime: "",
        introduction: "",
        isTransform: ""
      },
      showError: false,
      showCover: false,
      showAppViewer: false,
      publicData: [],
      
    };
  },
  created() {
    this.getSysParamByTypes([
      "IS_VALID",
    ]);
    this.addTitle = "直播详情";
    let id = this.$route.query.id;
      // 处理编辑或者详情
    this.getLiveRoomInfo(id);

  },
  methods: {
    goBack() {
      this.$router.push("/liveManage");
    },
    
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // this.typeList = res.data["CLIENT_TYPE_BANNER"];
        this.publicData = res.data["IS_VALID"] || [];
      });
    },

    getLiveRoomInfo(id) {
      liveRoomInfo(id).then((res) => {
        if (!res || res.code != 0) return;
        const { data = {} } = res;
        this.ruleForm = {
          ...data,
          isApp: Number(data.isApp),
          isWeb: Number(data.isWeb),
          isApplet: Number(data.isApplet),
          isPc: Number(data.isPc),
          liveTime: [data.startDate, data.endDate],
          isTransform: Number(data.isTransform),
        };
      });
    },


    closeAppViewer() {
      this.showAppViewer = false;
    },


    cancel() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.download_text {
  color: #3a85ff;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: left;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 20px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}
</style>
